import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import DisableMFA from '../../pages/DisableMFA'
import { getUser, getSiteKey } from '../../selectors/initialization'
import { getMfaState } from '../../selectors/settings'
import {
  revokeAllMfaMechanisms,
  revokeMfaMechanism
} from '../../actions/mfaSettings'
import { executeRecaptcha } from '../../actions/secureForm'
import { withCenteredBaseWithMenu } from '../../components/Base'

export const mapStateToProps = createSelector(
  [getUser, getMfaState, getSiteKey],
  (user, mfaState, siteKey) => ({
    user,
    isLastMFAMechanism: mfaState.isLastMFAMechanism,
    mfaToRevoke: mfaState.mfaToRevoke,
    isMFARevokeInProgress: mfaState.isMFARevokeInProgress,
    isSuccessfullyRevoked: mfaState.isSuccessfullyRevoked,
    revokeMFAErrorCode: mfaState.revokeMFAErrorCode,
    siteKey
  })
)

export const mapDispatchToProps = dispatch => ({
  onRevokeAllMFAMechanisms: ({ password, recaptchaResponse }) =>
    dispatch(revokeAllMfaMechanisms({ password, recaptchaResponse })),
  onRevokeMFAMechanism: ({ mfaMechanism, password, recaptchaResponse }) =>
    dispatch(revokeMfaMechanism({ mfaMechanism, password, recaptchaResponse })),
  onExecuteRecaptcha: () => dispatch(executeRecaptcha())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withCenteredBaseWithMenu(DisableMFA))
